import { useRef } from 'react';
import PropTypes from 'prop-types';
import { FocusScope, OverlayContainer, useDialog, useModal, useOverlay, usePreventScroll } from 'react-aria';

import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from './Dialog.module.scss';

const Dialog = ({ children, ...props }) => {
    const { isOpen } = props;
    // Handle interacting outside the dialog and pressing
    // the Escape key to close the modal.
    const ref = useRef();
    const { overlayProps, underlayProps } = useOverlay(props, ref);

    // Prevent scrolling while the modal is open, and hide content
    // outside the modal from screen readers.
    usePreventScroll();
    const { modalProps } = useModal();

    // Get props for the dialog
    const { dialogProps } = useDialog(props, ref);

    return (
        isOpen &&
            <OverlayContainer>
                <div
                    className={styles.backdrop}
                    {...underlayProps}
                    data-testid = {props['data-testid'] ? props['data-testid'] + '.backdrop' : null}
                >
                    <FocusScope contain restoreFocus autoFocus>
                        <div
                            aria-modal="true"
                            className={styles.modal}
                            {...overlayProps}
                            {...dialogProps}
                            {...modalProps}
                            ref={ref}
                            data-testid = {props['data-testid'] ? props['data-testid'] : null}
                        >
                            {children}
                        </div>
                    </FocusScope>
                </div>
            </OverlayContainer>
    );
};

Dialog.propTypes = {
    ...defaultAriaProps,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    isDismissable: PropTypes.bool
};

Dialog.defaultProps = {
    isOpen: false,
    isDismissable: true
};

export default Dialog;
